var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"add-document"},[_c('nice-file',{ref:"fileInput",attrs:{"watercolor":"","icon":"load","icon-placement":"start","icon-state":"180","accept":_vm.accept,"multiple":true,"disabled":_vm.disabled},on:{"change":_vm.filesChangeHandler}},[_vm._v(" "+_vm._s(_vm.$t('campaign.upload_doc_btn_label'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }